import { render } from "./HighlightTextValue.vue?vue&type=template&id=37d08a3e"
import script from "./HighlightTextValue.vue?vue&type=script&lang=js"
export * from "./HighlightTextValue.vue?vue&type=script&lang=js"

import "./HighlightTextValue.vue?vue&type=style&index=0&id=37d08a3e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__